import { DAMAGE_STATES } from '@hbrisk/sp3-risk-model-support/components/app/attributes/names/index.js';

const damageStateFieldArrayItemNameFromIndex = i => `${DAMAGE_STATES}[${i}]`;

export default damageStateFieldArrayItemNameFromIndex;
